import type {Maybe} from '@/types'
import type {MaybeRef} from 'node_modules/@tanstack/vue-query/build/modern/types'
import {computed, toValue} from 'vue'
import {Tier} from '@/client/mentor/CreditUsageClient'
import {useI18n} from 'vue-i18n'

const TIER_LOCAL_KEY: Record<Tier, string> = {
  [Tier.CUSTOM]: 'assistant.creditUsage.tiers.custom', // t('assistant.creditUsage.tiers.custom')
  [Tier.DISABLED]: 'assistant.creditUsage.tiers.disabled', // t('assistant.creditUsage.tiers.disabled')
  [Tier.SMART]: 'assistant.creditUsage.tiers.smart', // t('assistant.creditUsage.tiers.smart')
}

export function useAssistantTierName(tier: MaybeRef<Maybe<Tier>>) {
  const {t} = useI18n()
  const tierName = computed(() => t(TIER_LOCAL_KEY[toValue(tier) ?? Tier.DISABLED]))
  return tierName
}
